import React, { memo } from 'react';
import {Box, Flex} from '@chakra-ui/react';
import DonutChart from '../../../components/DonutChart';
import NoAvailable from '../../../components/NoAvailable';

const TransactionDonutChart = ({ data, transactionSize = 0 }: { data: any[], transactionSize: number }) => {
  return <>
    <Flex direction={{
      base: 'column',
      md: 'row'
    }} wrap="wrap" justify="space-between" pt="0.5rem">
      {
        transactionSize === 0 ? (<Box width="100%"><NoAvailable/></Box>) : (
          <>
            {
              data.map((chart, index) => (
                <Box key={`donut-chart-${index}`} width={["100%", "100%", "48%", "48%"]} mb="1.5rem">
                  <DonutChart data={chart.data} title={chart.title}/>
                </Box>
              ))
            }
          </>
        )
      }
    </Flex>
  </>;
};

export default memo(TransactionDonutChart);
